import React, { useEffect, useState } from 'react';
import './style.css';// Componente Main
import api from '../../services/api';
import { useNavigate, useLocation } from 'react-router-dom';
import TimerButton from '../Timer';
import { NiveisAcesso } from '../../constants/niveisAcesso';

export const Main = ({ children }: any) => {
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const location = useLocation();

  const [isOpen, setIsOpen] = useState(false);
  const [userName, setUserName] = useState('');
  const [showTimerButtonRoutes, setShowTimerButtonRoutes]: any = useState([]);
  const [nivelAcesso, setNivelAcesso] = useState(0);

  useEffect(() => {
    handleSearchPlan();
  }, []);

  useEffect(() => {
    api.get('nivel-acesso').then((response: any) => {
      setNivelAcesso(response.data.nivel)
    })
  }, [])

  const handleSearchPlan = async () => {
    const response = await api.post('buscar-free-trial');
    const freeTrial = response.data;
    if (freeTrial == true) {
      const showTimerButtonRoutes = [
        '/pcmso',
        '/pgr',
        '/pagamentos',
        '/empresas',
        '/documentos',
        '/funcionarios',

      ];

      setShowTimerButtonRoutes(showTimerButtonRoutes)
    } else {
      const showTimerButtonRoutes = [
        '/pcmso',
        '/pgr'
      ];

      setShowTimerButtonRoutes(showTimerButtonRoutes)
    }
  }

  const showTimerButton = showTimerButtonRoutes.some((path: string) => location.pathname.startsWith(path));
  return (
    <div className="main">
      {showTimerButton && nivelAcesso != NiveisAcesso.ADMIN && nivelAcesso != NiveisAcesso.RESPONSAVEL && <TimerButton />}
      {children}
    </div>
  );
};

